// random helpers

export function pick(object, keys) {
  return keys.reduce((acc, key) => {
    if (object[key]) {
      acc[key] = object[key];
    }
    return acc;
  }, {});
}

export function uniqBy(array, fn) {
  return [
    ...array
      .reduce((map, item) => {
        const key = fn(item);

        if (!map.has(key)) {
          map.set(key, item);
        }

        return map;
      }, new Map())
      .values()
  ];
}

export function sortBy(array, iteratees) {
  return array.sort((a, b) => {
    // eslint-disable-next-line no-restricted-syntax, no-unused-vars
    for (const fn of iteratees) {
      const result = applyRank(a, b, fn);
      if (result) {
        return result;
      }
    }
    return 0;
  });
}

function applyRank(a, b, fn) {
  const r1 = fn(a);
  const r2 = fn(b);
  if (r1 < r2) {
    return -1;
  }
  if (r1 > r2) {
    return 1;
  }
  return 0;
}

export function debounce(fn, millis = 200) {
  let timeout;

  // eslint-disable-next-line func-names
  return function(...args) {
    const functionCall = () => fn.apply(this, args);

    clearTimeout(timeout);
    timeout = setTimeout(functionCall, millis);
  };
}

export function isFunction(param) {
  return typeof param === 'function';
}
